import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import { TitleValuesByCourseIdQueryString } from "../../models/query-strings/education/course-chapter/TitleValuesByCourseIdQueryString";
import BaseService from "../base/BaseService";

export default class CourseChapterService extends BaseService {
    getTitleValueByCourseId(queryString: TitleValuesByCourseIdQueryString): Promise<TitleValue<number>[]> {
        return axios.get( "/CourseChapter/TitleValues", { params: queryString})
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }
}